import React from 'react';
import { View } from 'react-native';
import {
  addPathToList,
  Allow_customers_add_reason,
  custom,
  Design_layout,
  disabled_customer_will_skip,
  Enable_customers_add_photo,
  Enable_customers_add_reason,
  enter_free_text,
  Free_text,
  getSubCategoryId,
  payment_reason,
  Reference_str,
  select_a_photo,
  select_payment_reason,
  Select_reason,
} from '../../../utils/DictionaryManagementUtils';
import FullPagePanel from '../General/FullPagePanel';
import { arrangeScreenInJson } from '../../../screens/ScreensOrdering';
import SwitcherPanel from '../Buttons/SwitcherPanel';
import RadioPanelMenu from '../Buttons/RadioPanelMenu';
import NoteMessage from '../Text/NoteMessage';

//= ========================================================================

const DefaultReference = ({
  globJSON,
  onConfigChanged,
  selectedScreen,
  onStepPressed,
  onGotoEdit,
  language,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { reference } = globJSON.configurations.services[subCategoryId];
  const editTextList = [
    'add_a_reference',
    'payment_reason',
    'select_payment_reason',
    'custom',
    'enter_free_text',
    'next',
    'select_a_photo',
  ].filter((textElement) => {
    if (textElement === payment_reason || textElement === custom || textElement === select_payment_reason) {
      if (textElement === custom) {
        return reference.select_reason_from_options && reference.custom_reason;
      }
      return reference.select_reason_from_options;
    }
    if (textElement === select_a_photo) {
      return reference.customers_add_photo_enabled;
    }
    return true;
  });

  const onValueChanged = (key, value) => {
    reference[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Reference_str}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/reference/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={Allow_customers_add_reason}
      disableEditElements={!reference.step_enabled}
      language={language}
    >
      <SwitcherPanel
        text={Enable_customers_add_reason}
        value={reference.step_enabled}
        onValueChanged={(value) => {
          onValueChanged('step_enabled', value);
        }}
        marginBottom={0}
      />
      {reference.step_enabled
      && (
        <View>
          <RadioPanelMenu
            radioPanelValueChanged={reference.select_reason_from_options}
            expandedComponentValue={reference.custom_reason}
            screenOptions={reference}
            onPressLeftOption={(value) => {
              onValueChanged('select_reason_from_options', value);
            }}
            onPressRightOption={(value) => {
              onValueChanged('custom_reason', value);
            }}
            headline={Design_layout}
            headlineLeftOption={Select_reason}
            headlineRightOption={Free_text}
            language={language}
          />
          <SwitcherPanel
            text={Enable_customers_add_photo}
            value={reference.customers_add_photo_enabled}
            onValueChanged={(value) => {
              onValueChanged('customers_add_photo_enabled', value);
            }}
            marginBottom={32}
          />
        </View>
      )}
      {!reference.step_enabled && <NoteMessage language={language}>{disabled_customer_will_skip}</NoteMessage>}
    </FullPagePanel>
  );
};

export default DefaultReference;
